import qs from 'query-string';
import { jwCDNUrl } from '../constants';
import log from '../utils/logging';
import { getBrandAdScheduleId } from './adScheduleIDs';

const addArticleDataToAdTag = (
  /** @type {string} */ tag,
  /** @type {import('../utils/getArticleData').LabArticleData} */ articleData,
  /** @type {object} */ videoData
) => {
  const { id: articleId = '<undefined>' } = articleData;
  const { wasYouplay } = videoData;

  const { url, query: tagQuery } = qs.parseUrl(tag);

  const custParams = tagQuery.cust_params;
  // `custParams` *should* be single valued, but better be safe than sorry.
  const [params] = Array.isArray(custParams) ? custParams : [custParams];
  const custParamsObj = qs.parse(params);
  // Add 'verticals'
  if ('verticals' in articleData) {
    const articleVerticals = (articleData.verticals && articleData.verticals.length > 0 && articleData.verticals) || [];
    // Put verticals in a set to create a list with unique values
    const verticalsSet = new Set([
      ...(Array.isArray(articleVerticals) ? articleVerticals : articleVerticals.split(',')),
      ...(window?.aller_ga?.verticals || []),
    ]);
    const verticals = Array.from(verticalsSet);
    log.info(`Adding verticals to JW player ad tags: ${verticals} for player in article #${articleId}`);
    // eslint-disable-next-line
    custParamsObj['Vertikal'] = verticals.join(',');
  }

  // Add converted to youplay measurement
  if (wasYouplay) {
    // maybe have youplay ID here?
    log.info(`Adds measurement for youplay convert in article #${articleId}`);
    // eslint-disable-next-line
    custParamsObj['videoplayer'] = 'youplay';
  }
  return `${url}?${qs.stringify({
    ...tagQuery,
    cust_params: qs.stringify(custParamsObj),
  })}`;
};

/**
 * Add override default advertising configuration.
 * @param {object} defaultAdConfig - The `advertisement` property from the JW player config (typically
 * `jwplayer.defaults`)
 * @param {import('../utils/getArticleData').LabArticleData} articleData
 * @return {object} Modified player config
 */
export const getAdsConfig = async (articleData, videoConfig) => {
  const brand = window.aller_video.brand;
  // Get brand specific adscheduleid based on if a video is autoplay or click to play
  const adscheduleid = getBrandAdScheduleId(brand, videoConfig.autostart === 'viewable' ? 'autoPlay' : 'clickToPlay');

  const advertisingDefaults = await (await fetch(`${jwCDNUrl}v2/advertising/schedules/${adscheduleid}.json`)).json();
  const { schedule } = advertisingDefaults;

  if (!schedule) {
    throw new Error(`No ad schedule found in supplied ad config`);
  }

  return {
    schedule: schedule.map(({ tag }) => ({
      tag: addArticleDataToAdTag(tag, articleData, videoConfig),
    })),
    adscheduleid,
  };
};
